import React from "react";
import { parsePartidaDate } from "../../utils";

const DateRange = ({
  start_label,
  end_label,
  start_date,
  end_date,
  onTime,
}) => {
  return (
    <div className="row small">
      <div className="col-6 ">
        {start_label && (
          <span className="h6 titleInputPlantilla">{start_label}</span>
        )}
        <div className="calendarContainer mt-1">
          <span className={`${onTime ? "" : "text-danger"}`}>
            {parsePartidaDate(start_date).isValid()
              ? parsePartidaDate(start_date).format("DD MMM YYYY")
              : "N/D"}
          </span>
          <i className={`fa fa-calendar-alt text-${onTime ? "text-primary": "text-dark"}`}></i>
        </div>
      </div>
      <div className="col-6 ">
        {end_label && (
          <span className="h6 titleInputPlantilla">{end_label}</span>
        )}
        <div className="calendarContainer mt-1">
          <span className={`${onTime ? "" : "text-danger"}`}>
            {parsePartidaDate(end_date).isValid()
              ? parsePartidaDate(end_date).format("DD MMM YYYY")
              : "N/D"}{" "}
          </span>
          <i className={`fa fa-calendar-alt text-${onTime ? "text-primary": "text-dark"}`}></i>
        </div>
      </div>
    </div>
  );
};

export default DateRange;
